import Root from "./components/App/Main.js";
import React, { createContext } from "react";
import ReactDOM from "react-dom";
import { REDESIGN_ENABLED } from "./config/config.js";

if (REDESIGN_ENABLED) {
  document.documentElement.classList.add("redesign");

  // Not static in index.html: legacy mobile rendering relies on the default 980px layout.
  if (!document.querySelector('meta[name="viewport"]')) {
    const viewport = document.createElement("meta");
    viewport.name = "viewport";
    viewport.content = "width=device-width, initial-scale=1";
    document.head.appendChild(viewport);
  }
}

ReactDOM.render(<Root />, document.getElementById("root"));


// This error is result of a poor implementation by W3C draft, see https://github.com/w3c/csswg-drafts/issues/5488
// Removed from webpack overlay and redirected here to console

window.addEventListener('error', function (e) {
  if (e.message === "ResizeObserver loop completed with undelivered notifications.") {
    console.debug(e)
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

